import type { Prototype } from "../prototype-types";

export const catWuPrototypes: Prototype[] = [
  {
    id: "editorial-content",
    name: "Editorial Content",
    path: "/cwu/editorial-content",
    description:
      "Bestsellers by category with location filter. Stack-ranked bestsellers with map picker and multiselect states.",
    owner: "Catwu",
    createdAt: "2026-03-05",
    lastUpdated: "2026-04-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/750a4038a631536e520324a69d1029a52e4c608f05ce8820e8a9ab973d6670b9.png",
    creationTool: "claude-code",
  },
  {
    id: "virtual-tradeshow",
    name: "Virtual Tradeshow",
    path: "/cwu/virtual-tradeshow",
    description:
      "Browse our top brands and their catalogs to create assortments for your store.",
    owner: "Catwu",
    createdAt: "2026-03-05",
    lastUpdated: "2026-04-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/cc4a420a81de0120401bf40cf1dfcee2c6f1d04131fa62fe59d03b90a7ee62f2.png",
    creationTool: "claude-code",
  },
];
